import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import fetchTypeContracts from '../apis/fetchTypeContracts';
import type { TypeContract } from '../types/typeContract';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchTypeContracts = (): UseQueryResult<TypeContract[], Error> => {
    return useQuery<ApiResponse<TypeContract[]>, Error, TypeContract[]>({
        queryKey: withPrefix(['typeContracts']),
        queryFn: fetchTypeContracts,
        select: (response) => {
            if (response.status !== 200) {
                throw new Error(response.message);
            }
            return response.data as TypeContract[];
        },
    });
};
